export const GET_FIRMS_QUERY = `
  query GetFirms($where: firms_bool_exp = {}, $limit: Int, $offset: Int, $order_by: [firms_order_by!] = [{ created_at: desc }]) {
    firms_aggregate(where: $where) {
      aggregate { count }
    }
    firms(where: $where, order_by: $order_by, limit: $limit, offset: $offset) {
      id
      company_id
      firm_name
      firm_short_name
      firm_city
      firm_references
      description
      luca_code
      is_established
      partner_referral
      reference_type
      reference_firm_id
      reference_text
      created_at
      updated_at
      company {
        id
        name
      }
      reference_firm {
        id
        firm_name
        firm_short_name
      }
      firm_partners {
        partner_id
      }
      firm_sectors {
        sector_id
      }
      firm_carts {
        id
      }
      contracts {
        id
        contract_subject_id
        contract_subject {
          id
          name
          is_project_based
        }
        scope_of_work {
          id
          name
        }
        firm {
          id
          firm_name
          firm_short_name
        }
        contract_signing_date
        invoice_issue_date
        auto_renewal
        first_price_increase_period
        work_start_date
        # Sozlesme geldi mi? DIKKAT: alan adi anlaminin TERSI —
        # true = "Geldi", false = "Gelmedi" (bkz. useContracts.js
        # transformData). Ciro uyarilarinda kullanilir.
        work_started_without_contract
        protocol_start_date
        protocol_end_date
        renewal_period
        inflation_clause
        pricing_method_id
        work_status {
          id
          name
        }
        pricing_method {
          id
          name
        }
        invoices_aggregate {
          aggregate {
            sum {
              total_unit_price
            }
            count
          }
        }
        invoices(order_by: { created_at: asc }) {
          id
          total_unit_price
          payment_schedules
          # V2 formatinda odeme plani invoice_code_ids JSONB icinde her
          # kalemin kendi schedules array'inde saklanir (V1 flat
          # payment_schedules yerine). pickMonthlyForMonth iki formata
          # da bakar. Onceden fetch edilmiyordu ve V2 kayitlarda ay-bazli
          # tutar bulunamiyordu. Bug: Hopi/BNR Teknopark Q2 86 beklenirken
          # 99 hesaplaniyordu; Nisan icinde amount 24000 degistirilmisti.
          invoice_code_ids
          created_at
          # pricing_process — kanal bazli invoice filter icin (ornegin
          # ONAY_SONRASI cirosunda sadece 'onay' isimli surece bagli
          # faturalari sayabilmek icin). Bkz. revenueCalculation.js
          pricing_process_id
          pricing_process {
            id
            name
          }
        }
        renewals(order_by: { renewal_start_date: asc }) {
          id
          renewal_start_date
          renewal_end_date
          new_monthly_amount
        }
      }
      jobs {
        id
        job_title
        job_type
        job_type_id
        # IS TURU BAYRAGI — proje tarihi kontrolu buna bakiyor.
        #
        # Onceden yalnizca job_type metni cekiliyordu. O kolon artik
        # opsiyonel (bkz. 1783100000000_drop_jobs_job_type_fk); yeni
        # isler yalnizca job_type_id ile aciliyor ve metin bos geliyor.
        # Bayrak cekilmedigi icin isProjectBasedJob metin yedegine
        # dusuyor, bos metin de hicbir ture uymuyordu — teknopark isleri
        # "proje bazli" sayilip ciro girisinde proje tarihi istiyordu.
        job_type_rel { id name is_project_based }
        project_number
        contract_id
        job_status
        description_of_job
        # Uzatma/oteleme kayitlari (JSONB). Ciro hesaplamada projeye
        # yeni bitis tarihi vermek icin gerekli. Onceden fetch edilmiyordu
        # ve pickLatestExtensionEnd her zaman null donuyordu, bu yuzden
        # sistem uzatma sonrasi tarihi degil eski tarihi kullaniyordu.
        # Bug: Ekinler 3240344 TUBITAK - uzatma alinsa da bitis tarihi
        # eski tarih olarak goruluyordu.
        project_extensions
        contract {
          id
          contract_signing_date
          contract_description
          # true = "Geldi", false = "Gelmedi" (ters isimlendirme).
          work_started_without_contract
        }
        job_details(order_by: { created_at: desc }) {
          id
          job_detail_type
          detail_data
          created_at
          # Gecmis tablosundaki "Islem Yapan" sutunu bu iliskiden geliyor.
          user { first_name last_name }
        }
      }
    }
  }
`;

export const GET_FIRM_BY_ID_QUERY = `
  query GetFirmById($id: Int!) {
    firms_by_pk(id: $id) {
      id
      company_id
      firm_name
      firm_short_name
      firm_city
      firm_references
      description
      luca_code
      is_established
      partner_referral
      reference_type
      reference_firm_id
      reference_text
      created_at
      updated_at
      company {
        id
        name
      }
      reference_firm {
        id
        firm_name
        firm_short_name
      }
      firm_partners {
        partner_id
      }
      firm_sectors {
        sector_id
      }
    }
  }
`;

export const GET_FIRMS_BY_NAME_QUERY = `
  query GetFirmsByName($pattern: String!, $companyId: Int!) {
    firms(
      where: {
        company_id: { _eq: $companyId }
        firm_name: { _ilike: $pattern }
      }
      limit: 8
      order_by: { firm_name: asc }
    ) {
      id
      firm_name
      firm_short_name
    }
  }
`;

export const GET_FIRMS_BY_SHORT_NAME_QUERY = `
  query GetFirmsByShortName($pattern: String!, $companyId: Int!) {
    firms(
      where: {
        company_id: { _eq: $companyId }
        firm_short_name: { _ilike: $pattern }
      }
      limit: 8
      order_by: { firm_short_name: asc }
    ) {
      id
      firm_name
      firm_short_name
    }
  }
`;

export const GET_FIRMS_FOR_REFERENCE_QUERY = `
  query GetFirmsForReference($companyId: Int!) {
    firms(where: { company_id: { _eq: $companyId } }, order_by: { firm_name: asc }) {
      id
      firm_name
      firm_short_name
    }
  }
`;

export const GET_FIRM_DETAIL_QUERY = `
  query GetFirmDetail($id: Int!) {
    firms_by_pk(id: $id) {
      id
      firm_name
      firm_short_name
      firm_city
      is_established
      partner_referral
      reference_type
      reference_text
      luca_code
      description
      company_id
      created_at
      updated_at
      company { id name }
      reference_firm { id firm_name firm_short_name }
      firm_partners {
        id
        partner { id partner_name }
      }
      firm_sectors {
        id
        sector { id sector_name }
      }
      contracts(order_by: { created_at: desc }) {
        id
        contract_signing_date
        work_start_date
        auto_renewal
        contract_subject { id name }
        scope_of_work { id name }
        pricing_method { id name }
        work_status { id name }
      }
      jobs(order_by: { created_at: desc }) {
        id
        job_title
        job_status
        job_type
        job_type_id
        job_type_rel { id name is_project_based }
        project_number
        user { id first_name last_name }
        job_assignment {
          id
          technical_user { id first_name last_name }
          financial_user { id first_name last_name }
        }
      }
    }
    offers(where: { firm_id: { _eq: $id } }, order_by: { created_at: desc }) {
      id
      proposal_date
      proposal_given
      contract_subject { id name }
      scope_of_work { id name }
      proposal_status { id name }
      user { id first_name last_name }
    }
    invoices(where: { firm_id: { _eq: $id } }) {
      id
      total_unit_price
    }
  }
`;